module.exports = __webpack_public_path__ + "img/graphic-mobilesvg.a525093c.svg";